/*
 * @fileOverView LazyLoad Mixin.
 */

import Blazy from 'blazy';

export default {
  methods: {
    /**
     * Will init lazy loading or revalidatewith options provided
     *
     * @param {*} container
     * @returns
     */
    lazyLoad(options) {
      if (this.bLazy) {
         this.bLazy.revalidate();
         return;
      }

      const bLazyDefaults = {
        //when reloading a page in the middle, scrolling to the top will never reveal the top items unless this is 0: default is 100
        offset: 0
      };

      this.bLazy = new Blazy({...bLazyDefaults, ...options});
    }
  }
}
